export const posEn = {
  "pos.inventory.title": "Stock receiving",
  "pos.jonas.queue.pending": "Needs settings review",
  "pos.jonas.queue.confirmed": "Settings confirmed",
  "pos.jonas.queue.blocked": "Retained deletion markers",
  "pos.jonas.queue.all": "All imported items",
  "pos.suppliers.title": "Jonas supplier review",
  "pos.suppliers.help": "Link an exact legacy supplier code only after confirming the correct vendor. This leaves items archived and does not change prices, stock or printing.",
  "pos.suppliers.missing": "{count} source records have no supplier code and require individual evidence.",
  "pos.suppliers.code": "Unlinked supplier code",
  "pos.suppliers.search": "Search active vendors (first 50 matches)",
  "pos.suppliers.vendor": "Confirmed vendor",
  "pos.suppliers.preview": "Preview supplier links",
  "pos.suppliers.records": "{count} exact source records will be linked.",
  "pos.suppliers.ack": "I have verified that this Jonas supplier code belongs to the selected vendor.",
  "pos.suppliers.apply": "Apply reviewed supplier links",
  "pos.suppliers.saved": "Supplier links saved. Catalogue prices and sale status are unchanged.",

  "pos.jonas.comparePrices": "Compare Jonas prices",
  "pos.jonas.priceSafety": "Source comparison only. Items remain archived; no prices or printing are activated.",
  "pos.jonas.priceOrigins": "Regular comes from the sales catalogue. Member and retail come from linked inventory records. Blank or zero values are not approved free prices. Scheduled changes are shown separately.",
  "pos.jonas.onlyDifferences": "Show differing positive prices only",
  "pos.jonas.priceTotals": "{total} linked items; {paired} have both sales and inventory sources.",
  "pos.jonas.pricePairs": "Member vs retail: {equal} equal, {different} different. Regular vs retail: {regularDifferent} different. Counts compare positive prices only.",
  "pos.jonas.regularPrice": "Regular (sales)",
  "pos.jonas.memberPrice": "Member (inventory)",
  "pos.jonas.retailPrice": "Retail (inventory)",
  "pos.jonas.scheduledPrices": "Scheduled source values and dates",
  "pos.jonas.priceState.positive": "Positive source value",
  "pos.jonas.priceState.zero": "Zero — needs review",
  "pos.jonas.priceState.negative": "Negative — needs review",
  "pos.jonas.priceState.blank": "Blank in source",
  "pos.jonas.priceState.not_applicable": "No linked source of this type",
  "pos.jonas.priceState.missing_field": "Field missing in source",
  "pos.jonas.priceState.ambiguous": "Ambiguous source values",
  "pos.jonas.priceState.invalid": "Invalid price value",
  "pos.jonas.suppliers": "Linked Jonas suppliers",
  "pos.jonas.saleReview": "Imported items needing review",
  "pos.jonas.saleReviewHelp": "These items remain off sale. Review the source, edit the sale settings below, confirm them, choose an active category and set outlet prices before restoring.",
  "pos.jonas.confirmSettings": "I have reviewed and confirm these sale settings",
  "pos.jonas.reviewConfirmed": "Sale settings confirmed",
  "pos.jonas.previousReviews": "Previous 50 items",
  "pos.jonas.nextReviews": "Next 50 items",

  "pos.jonas.retained": "Source retained for review",
  "pos.jonas.title": "Jonas catalogue review",
  "pos.jonas.subtitle": "Review imported sales items and retail SKUs, then prepare linked POS drafts.",
  "pos.jonas.safety": "Source records are preserved. Creating a draft keeps it archived, without prices, inventory quantities, orders or printing. Review its settings and prices before restoring it for sale.",
  "pos.jonas.empty": "No Jonas catalogue snapshots have been imported for this club.",
  "pos.jonas.dataset": "Source snapshot",
  "pos.jonas.search": "Search imported names, codes or barcodes",
  "pos.jonas.complete": "Complete source: {rows} of {expected} records",
  "pos.jonas.incomplete": "Source incomplete: {rows} of {expected} records. Draft creation is unavailable.",
  "pos.jonas.linkedCount": "{count} linked to POS items",
  "pos.jonas.noRecords": "No matching source records.",
  "pos.jonas.code": "Source code",
  "pos.jonas.review": "Review status",
  "pos.jonas.missing": "Not provided",
  "pos.jonas.openItem": "Open linked POS item",
  "pos.jonas.createDraft": "Create linked POS draft",
  "pos.jonas.draftHint": "Choose the POS item type, tax, service charge and minimum settings explicitly. Prices and active status are never inferred from Jonas. The draft opens in the item editor for further review.",
  "pos.jonas.choose": "Choose…",
  "pos.jonas.standard": "Standard",
  "pos.jonas.exempt": "Exempt",
  "pos.jonas.required": "Enter a name and choose the type, tax, service charge and minimum settings.",
  "pos.jonas.back": "Back to catalogue review",
  "pos.jonas.sourceDetails": "Source details",
  "pos.jonas.prices": "Source price candidates",
  "pos.jonas.priceHint": "Positive prices are shown for reference only. Future, member and regular prices can mean different things. Blank, zero, negative or invalid prices are not sale prices. Set outlet prices in the item editor.",
  "pos.jonas.noPrice": "No valid positive price",
  "pos.jonas.related": "Related sales and retail records",
  "pos.jonas.truncated": "Showing the first 50 related records. Search the source snapshot for the full list.",
  "pos.jonas.fields": "Original source fields",
  "pos.jonas.showEmpty": "Show empty fields too",
  "pos.jonas.position": "Position",
  "pos.jonas.field": "Source field",
  "pos.jonas.value": "Original value",
  "pos.jonas.source.items": "Sales items",
  "pos.jonas.source.retail": "Retail SKUs",
  "pos.jonas.source.categories": "Sales categories",
  "pos.jonas.source.areas": "Sales areas",
  "pos.jonas.issue.missing_code": "Source code needs review",
  "pos.jonas.issue.missing_name": "Name needs review",
  "pos.jonas.issue.no_positive_price": "No positive price confirmed",
  "pos.jonas.issue.status_unconfirmed": "Active status unconfirmed",
  "pos.jonas.issue.missing_pos_reference": "No sales item reference",
  "pos.jonas.issue.ambiguous_fields": "Repeated key fields need review",
  "pos.jonas.related.available": "Exact source-code references are shown below. These do not automatically merge items, variants, supplier links or stock.",
  "pos.jonas.related.not_found": "No exact reference was found in the available source.",
  "pos.jonas.related.missing_reference": "The source does not identify a sales item.",
  "pos.jonas.related.source_incomplete": "The related source has not been completely imported.",
  "pos.jonas.related.ambiguous_source": "Multiple source versions have the same capture date. Resolve the source version before matching.",
  "pos.jonas.related.ambiguous_fields": "The source has repeated reference fields and cannot be matched safely.",
  "pos.jonas.related.not_applicable": "This source is a category or sales area.",

  "pos.register.backToClub": "Back to ClubCore",
  "pos.barcode.download": "Download label",
  "pos.barcode.generate": "Generate barcode",
  "pos.register.fullscreen": "Full screen",
  "pos.register.windowed": "Windowed",
  "pos.register.fullscreenFailed": "Full screen is unavailable.",
  "pos.register.scannerBusy": "Register is busy. Please scan that item again when ready.",
  "pos.register.scannerHint": "USB/Bluetooth scanner ready. Scan anywhere outside a text field, or enter a code here.",

  // Words used across the screens
  "pos.actions": "Actions",
  "pos.field.name": "Name",
  "pos.field.description": "Description",
  "pos.field.type": "Type",
  "pos.field.category": "Category",
  "pos.field.noCategory": "No category",
  "pos.field.photo": "Photo",
  "pos.field.sku": "SKU",
  "pos.field.skus": "SKUs",
  "pos.field.skuHint": "Letters, digits and - . / _ only. Leave empty for none.",
  "pos.field.barcode": "Barcode",
  "pos.field.taxTreatment": "Tax",
  "pos.field.serviceCharge": "Service charge",
  "pos.field.countsTowardMinimum": "Counts toward the food and beverage minimum",
  "pos.field.countsHint": "Only counts if the outlet's department counts too.",
  "pos.field.showInMemberApp": "Show in the member app",
  "pos.field.sortOrder": "Sort order",
  "pos.field.wholeNumber": "Enter a whole number.",
  "pos.type.retail": "Retail",
  "pos.type.food": "Food",
  "pos.type.beverage": "Beverage",
  "pos.type.service": "Service",
  "pos.treatment.standard": "Standard",
  "pos.treatment.exempt": "Exempt",
  "pos.outletType.dining": "Dining",
  "pos.outletType.bar": "Bar",
  "pos.outletType.pro_shop": "Pro shop",
  "pos.outletType.catering": "Catering",
  "pos.outletType.room_service": "Room service",
  "pos.outletType.other": "Other",
  "pos.status.active": "Active",
  "pos.status.archived": "Archived",
  "pos.active.on": "On",
  "pos.active.off": "Off",
  "pos.price.notSold": "Not sold here",
  "pos.price.range": "from {from} to {to}",
  "pos.rule.optionalAny": "Optional, any number",
  "pos.rule.optionalUpto": "Optional, up to {max}",
  "pos.rule.exactly": "Choose exactly {count}",
  "pos.rule.between": "Choose {min} to {max}",
  "pos.rule.atLeast": "Choose at least {min}",

  // Items list
  "pos.items.title": "Items",
  "pos.items.subtitle": "Everything the club sells: what it is, where it is sold and for how much.",
  "pos.items.new": "New item",
  "pos.items.search": "Search items",
  "pos.items.searchPlaceholder": "Name, SKU or barcode",
  "pos.items.anyType": "Any type",
  "pos.items.anyCategory": "Any category",
  "pos.items.status": "Status",
  "pos.items.status.active": "Active",
  "pos.items.status.archived": "Archived",
  "pos.items.status.all": "Active and archived",
  "pos.items.memberAppOnly": "Shown in the member app",
  "pos.items.priceAt": "Show price at",
  "pos.items.noOutlet": "No outlet",
  "pos.items.priceToday": "Price today",
  "pos.items.moreSkus": "+{more}",
  "pos.items.empty": "No items yet",
  "pos.items.emptyBody": "Add the first item to start the catalogue. Archived items can be shown with the Status filter.",
  "pos.items.noMatch": "No items match these filters",
  "pos.items.noMatchBody": "Change or clear the search and filters to see more.",

  // New item
  "pos.item.newTitle": "New item",
  "pos.item.add": "Add item",
  "pos.item.created": "{name} added.",
  "pos.item.nameRequired": "Enter a name.",
  "pos.item.variantNamesRequired": "Give every variant a name.",
  "pos.item.startWithVariants": "Start with several variants",
  "pos.item.addAnotherVariant": "Add another variant",
  "pos.item.variantNameN": "Variant {number} name",
  "pos.item.removeVariantN": "Remove variant {number}",

  // Item page
  "pos.item.title": "Item",
  "pos.item.back": "All items",
  "pos.item.archive": "Archive",
  "pos.item.restore": "Restore",
  "pos.item.archived": "{name} archived.",
  "pos.item.restored": "{name} restored.",
  "pos.item.details": "Details",
  "pos.item.saved": "{name} saved.",
  "pos.item.nothingToSave": "Nothing has changed.",
  "pos.item.variants": "Variants",

  // Photo
  "pos.photo.title": "Photo",
  "pos.photo.none": "No photo yet.",
  "pos.photo.add": "Add photo",
  "pos.photo.replace": "Replace photo",
  "pos.photo.remove": "Remove photo",
  "pos.photo.choose": "Choose a photo file",
  "pos.photo.saved": "Photo saved.",
  "pos.photo.removed": "Photo removed.",
  "pos.photo.removeTitle": "Remove this photo?",
  "pos.photo.removeBody": "The photo of {name} is deleted from ClubCore. The original file is not kept.",
  "pos.photo.notImage": "Choose a picture file (JPEG, PNG, WebP, GIF, BMP, TIFF or AVIF).",
  "pos.photo.tooLarge": "That file is larger than 15 MB.",

  // Variants
  "pos.variant.add": "Add variant",
  "pos.variant.addTitle": "Add a variant",
  "pos.variant.addRenameHint": "This item has one variant without a name. Both variants need a name now.",
  "pos.variant.renameExisting": "Name for the existing variant",
  "pos.variant.newName": "Name for the new variant",
  "pos.variant.added": "{name} added.",
  "pos.variant.editN": "Edit variant {name}",
  "pos.variant.editTitle": "Edit variant",
  "pos.variant.saved": "Variant saved.",
  "pos.variant.options": "Options",
  "pos.variant.optionsHint": "One per line, written as name: value (for example Size: Large).",
  "pos.variant.optionsBad": "Write each option as name: value. This line does not: {line}",
  "pos.variant.active": "Active",
  "pos.variant.activeLabel": "Active (can be sold)",
  "pos.variant.unnamed": "(no name)",
  "pos.variant.nameRequired": "Enter a name.",
  "pos.variant.renameRequired": "Enter a name for the existing variant.",
  "pos.variant.singleOnly": "Only retail items can have several variants. Food and drinks use modifier groups for their choices.",

  // Modifier groups on an item
  "pos.modifiers.title": "Modifier groups",
  "pos.modifiers.none": "This item asks for no modifier groups.",
  "pos.modifiers.pick": "Add a group",
  "pos.modifiers.choose": "Choose a group",
  "pos.modifiers.noneLeft": "No other groups",
  "pos.modifiers.add": "Add group",
  "pos.modifiers.added": "{name} added to the item.",
  "pos.modifiers.removed": "{name} removed from the item.",
  "pos.modifiers.moved": "{name} moved.",
  "pos.modifiers.up": "Up",
  "pos.modifiers.down": "Down",
  "pos.modifiers.moveUpN": "Move {name} up",
  "pos.modifiers.moveDownN": "Move {name} down",
  "pos.modifiers.removeN": "Remove {name}",

  // Prices
  "pos.prices.title": "Prices",
  "pos.prices.noOutlets": "The club has no outlets yet, so there is nowhere to set a price.",
  "pos.prices.outlet": "Outlet",
  "pos.prices.variant": "Variant",
  "pos.prices.today": "Price today",
  "pos.prices.next": "Next change",
  "pos.prices.noPrice": "No price",
  "pos.prices.changesTo": "{price} from {date}",
  "pos.prices.stopsFrom": "Stops selling from {date}",
  "pos.prices.set": "Set price",
  "pos.prices.setFor": "Set price at {outlet} {variant}",
  "pos.prices.setTitle": "Set a price for {name}",
  "pos.prices.save": "Save price",
  "pos.prices.saved": "Price saved.",
  "pos.prices.stopSaved": "Selling will stop on that date.",
  "pos.prices.chooseOutlet": "Choose an outlet",
  "pos.prices.outletRequired": "Choose an outlet.",
  "pos.prices.allVariants": "All variants",
  "pos.prices.amount": "Price",
  "pos.prices.amountHint": "In dollars, for example {example}.",
  "pos.prices.amountInvalid": "Enter a price such as {example}, with at most two decimals.",
  "pos.prices.starts": "Starts",
  "pos.prices.dateRequired": "Choose the date the price starts.",
  "pos.prices.stopSelling": "Stop selling here from this date",
  "pos.prices.stopSellingHint": "The item leaves this outlet's menu from that date.",
  "pos.prices.upcoming": "Prices that have not started yet",
  "pos.prices.upcomingPrice": "{price} from {date}",
  "pos.prices.removeFor": "Remove the price at {outlet} from {date}",
  "pos.prices.removed": "Price removed.",

  // Categories
  "pos.categories.title": "Categories",
  "pos.categories.subtitle": "How items are grouped for selling and reports. Two levels at most.",
  "pos.categories.new": "New category",
  "pos.categories.newTitle": "New category",
  "pos.categories.editTitle": "Edit category",
  "pos.categories.add": "Add category",
  "pos.categories.code": "Code",
  "pos.categories.codeHint": "Lower case letters, digits and - . _ , up to 32.",
  "pos.categories.codeRequired": "Enter a code.",
  "pos.categories.nameRequired": "Enter a name.",
  "pos.categories.parent": "Inside",
  "pos.categories.topLevel": "Top level",
  "pos.categories.itemCount": "Active items",
  "pos.categories.editN": "Edit {name}",
  "pos.categories.switchOff": "Switch off",
  "pos.categories.switchOn": "Switch on",
  "pos.categories.switchOffN": "Switch off {name}",
  "pos.categories.switchOnN": "Switch on {name}",
  "pos.categories.switchedOff": "{name} switched off. Its items are off the menus.",
  "pos.categories.switchedOn": "{name} switched on.",
  "pos.categories.created": "{name} added.",
  "pos.categories.saved": "{name} saved.",
  "pos.categories.empty": "No categories yet",
  "pos.categories.emptyBody": "Add a category to start grouping items.",

  // Modifier groups
  "pos.groups.title": "Modifier groups",
  "pos.groups.subtitle": "Sets of choices, such as steak temperature or sides, that food, beverage and service items share.",
  "pos.groups.new": "New group",
  "pos.groups.search": "Search groups",
  "pos.groups.show.active": "Active",
  "pos.groups.show.off": "Switched off",
  "pos.groups.show.all": "All",
  "pos.groups.rule": "Rule",
  "pos.groups.itemCount": "Items",
  "pos.groups.editN": "Edit {name}",
  "pos.groups.empty": "No modifier groups yet",
  "pos.groups.emptyBody": "Add a group to give food and drink items choices.",
  "pos.groups.noMatch": "No groups match these filters",
  "pos.groups.noMatchBody": "Change or clear the search and filter to see more.",
  "pos.group.newTitle": "New modifier group",
  "pos.group.editTitle": "Edit modifier group",
  "pos.group.add": "Add group",
  "pos.group.created": "{name} added.",
  "pos.group.saved": "{name} saved.",
  "pos.group.nameRequired": "Enter a name.",
  "pos.group.min": "Least to choose",
  "pos.group.minHint": "1 or more makes the choice required.",
  "pos.group.minInvalid": "Enter 0 or a whole number above it.",
  "pos.group.max": "Most to choose",
  "pos.group.maxHint": "Leave empty for any number.",
  "pos.group.maxInvalid": "Enter a whole number of 1 or more, or leave it empty.",
  "pos.group.activeLabel": "Group is on",
  "pos.group.choices": "Choices",
  "pos.group.noChoices": "No choices yet.",
  "pos.group.choiceN": "Choice {number}",
  "pos.group.choiceName": "Choice name",
  "pos.group.choiceNameRequired": "Enter a name for this choice.",
  "pos.group.priceChange": "Price change",
  "pos.group.priceHint": "Added to the item's price. Leave empty for none; a minus sign takes money off.",
  "pos.group.priceInvalid": "Enter an amount such as {example}, with at most two decimals.",
  "pos.group.preselected": "Preselected",
  "pos.group.choiceActive": "On",
  "pos.group.addChoice": "Add a choice",
  "pos.group.discardChoice": "Discard this choice",

  // Outlets
  "pos.outlets.title": "Outlets",
  "pos.outlets.subtitle": "Where the club sells from. Each outlet belongs to a billing department; revenue and tax follow it.",
  "pos.outlets.department": "Department",
  "pos.outlets.menu": "Menu",
  "pos.outlets.menuN": "Menu of {name}",
  "pos.outlets.editN": "Edit {name}",
  "pos.outlets.editTitle": "Edit outlet",
  "pos.outlets.nameRequired": "Enter a name.",
  "pos.outlets.saved": "{name} saved.",
  "pos.outlets.empty": "No outlets yet",
  "pos.outlets.emptyBody": "The club's outlets appear here.",
  "pos.outlets.departmentHint": "Revenue and tax follow the department.",
  "pos.outlets.departmentFixed": "Department: {name}.",
  "pos.outlets.departmentsUnavailable": "The list of departments needs billing access, so it cannot be changed here.",
  "pos.outlets.activeLabel": "Outlet is on",
  "pos.outlets.activeHint": "A switched-off outlet has no menu.",

  // Outlet menu
  "pos.menu.title": "Outlet menu",
  "pos.menu.titleFor": "Menu of {name}",
  "pos.menu.subtitle": "What a terminal would show.",
  "pos.menu.asOf": "As of {date}",
  "pos.menu.back": "All outlets",
  "pos.menu.date": "Show the menu on",
  "pos.menu.dateHint": "Leave empty for today at the club.",
  "pos.menu.memberAppOnly": "Member app items only",
  "pos.menu.noCategory": "No category",
  "pos.menu.required": "Required",
  "pos.menu.empty": "Nothing is on sale here on this date",
  "pos.menu.emptyBody": "An item appears when it is active and has a price at this outlet on the date.",
  "pos.menu.emptyMemberApp": "No item shown in the member app is on sale here on this date.",

  // Error codes from the server
  "apiError.price_in_past": "A price cannot start on a date that has already passed. Choose today or later.",
  "apiError.price_too_far_ahead": "A price cannot start more than three years from now.",
  "apiError.price_in_effect": "Only a price that starts in the future can be removed. Set a new price from a date instead.",
  "apiError.price_not_found": "That price no longer exists.",
  "apiError.category_too_deep": "Categories go two levels deep at most: a category that has sub-categories cannot go inside another, and a sub-category cannot hold others.",
  "apiError.category_cycle": "A category cannot be placed inside itself.",
  "apiError.category_code_taken": "A category with this code already exists.",
  "apiError.outlet_code_taken": "An outlet with this code already exists.",
  "apiError.outlet_inactive": "This outlet is switched off, so it has no menu.",
  "apiError.outlet_not_found": "That outlet no longer exists.",
  "apiError.department_not_found": "That department no longer exists.",
  "apiError.variant_not_found": "That variant no longer exists.",
  "apiError.variants_retail_only": "Only retail items can have more than one variant. Food and drinks use modifier groups for their choices.",
  "apiError.variant_name_required": "Every variant needs a name when an item has several.",
  "apiError.variant_name_taken": "Two variants cannot have the same name.",
  "apiError.sku_taken": "That SKU is already used by another variant.",
  "apiError.barcode_taken": "That barcode is already used by another variant.",
  "apiError.sku_with_variants": "Put the SKU and barcode on each variant, not on the item.",
  "apiError.modifiers_not_for_retail": "Retail items cannot ask for modifier groups.",
  "apiError.modifier_group_not_found": "That modifier group no longer exists.",
  "apiError.modifier_not_found": "That choice no longer exists.",
  "apiError.modifier_group_name_taken": "A modifier group with this name already exists.",
  "apiError.modifier_name_taken": "Two choices in a group cannot have the same name.",
  "apiError.not_enough_choices": "The group needs more choices that are switched on than the least to choose.",
  "apiError.invalid_selection_range": "The most to choose cannot be less than the least.",
  "apiError.too_many_defaults": "More choices are preselected than the most to choose allows.",
  "apiError.duplicate_group": "A group can be on an item only once.",
  "apiError.code_not_found": "No item has that SKU or barcode.",
  "apiError.photo_not_found": "This item has no photo.",
  "apiError.photo_not_an_image": "That file is not a picture ClubCore can read. Use JPEG, PNG, WebP, GIF, BMP, TIFF or AVIF.",
  "apiError.photo_empty": "That file is empty.",
  "apiError.photo_damaged": "That picture is damaged and cannot be read.",
  "apiError.photo_too_many_pixels": "That picture is too large in pixels. Use a smaller one.",
  "apiError.photo_heic": "HEIC pictures are not supported. Export the picture as JPEG first.",
  "apiError.photo_too_large": "That file is larger than 15 MB.",
} as const;

export type PosMessages = typeof posEn;
